import { createAction, createAsyncAction } from "typesafe-actions";

import type { QuotaOperationState } from "app/pages/sales-intelligence/modules/quota/types";
import type {
    MultiSelectorPanelType,
    SelectorPanelItemConfig,
} from "app/pages/sales-intelligence/sub-modules/common/types";

import type { FetchError } from "../../../types";
import type { RevealedContactDto } from "../../contacts-search/types/dto";

export const fetchLegacyWorkspaces = createAsyncAction(
    "@@si/common/FETCH_LEGACY_WORKSPACES_START",
    "@@si/common/FETCH_LEGACY_WORKSPACES_SUCCESS",
    "@@si/common/FETCH_LEGACY_WORKSPACES_FAILURE",
)<void, void, FetchError>();

export const setWorkspaceId = createAction("@@si/common/SET_WORKSPACE_ID")<string>();

export const toggleNotFoundListModalOpen = createAction("@@si/common/TOGGLE_NOT_FOUND_LIST_MODAL_OPEN")<boolean>();

export const toggleNotFoundLeadGenModalOpen = createAction(
    "@@si/common/TOGGLE_NOT_FOUND_LEAD_GEN_MODAL_OPEN",
)<boolean>();

export const fetchSimilarWebsitesAsync = createAsyncAction(
    "@@si/common/FETCH_SIMILAR_WEBSITES_START",
    "@@si/common/FETCH_SIMILAR_WEBSITES_SUCCESS",
    "@@si/common/FETCH_SIMILAR_WEBSITES_FAILURE",
)<void, { domain: string; similarWebsites: any[] }, FetchError>();

export const fetchWebsitesInfoAsync = createAsyncAction(
    "@@si/common/FETCH_WEBSITE_INFO_START",
    "@@si/common/FETCH_WEBSITE_INFO_SUCCESS",
    "@@si/common/FETCH_WEBSITE_INFO_FAILURE",
)<void, { domain: string; info: any }, FetchError>();

export const fetchExcelQuota = createAsyncAction(
    "@@si/common/FETCH_EXCEL_QUOTA_START",
    "@@si/common/FETCH_EXCEL_QUOTA_SUCCESS",
    "@@si/common/FETCH_EXCEL_QUOTA_FAILURE",
)<void, QuotaOperationState, FetchError>();

export const setMultiSelectorPanelAssignItemConfig = createAction(
    "@@si/common/SET_MULTI_SELECTOR_PANEL_ASSIGN_ITEM_CONFIG",
)<SelectorPanelItemConfig>();

export const setMultiSelectorPanel = createAction("@@si/common/SET_MULTI_SELECTOR_PANEL")<
    Omit<MultiSelectorPanelType, "selectedItemIndex">
>();

export const updateMultiSelectorPanel = createAction("@@si/common/UPDATE_MULTI_SELECTOR_PANEL")<
    Omit<MultiSelectorPanelType, "type">
>();

export const updateNotRevealedContactsIds = createAction("@@si/common/UPDATE_NOT_REVEALED_CONTACTS_IDS")<string[]>();

export const addRevealingContactIds = createAction("@@si/common/ADD_REVEALING_CONTACT_IDS")<string[]>();
export const removeRevealingContactIds = createAction("@@si/common/REMOVE_REVEALING_CONTACT_IDS")<string[]>();

export const updateRevealedContactsByUniqId = createAction("@@si/common/UPDATE_CONTAVTS_REVEALED_BY_UNIQ_ID")<
    RevealedContactDto[]
>();

export const updateRevealedContactsById = createAction("@@si/common/UPDATE_CONTAVTS_REVEALED_BY_ID")<
    RevealedContactDto[]
>();

export const setIsOnboardingWizardOpened = createAction("@@si/common/SET_IS_ONBOARDING_WIZARD_OPENED")<boolean>();

export const setIsExtensionBannerVisible = createAction("@@si/common/SET_IS_EXTENSION_BANNER_VISIBLE")<boolean>();

export const setIsColumnPickerOpen = createAction("@@si/common/SET_IS_COLUMN_PICKER_OPEN")<boolean>();

export const setActivePageTab = createAction("@@si/common/SET_ACTIVE_PAGE_TAB")<string | null>();
